/**
 * 服務條款完整內容
 * 🔒 此檔案為獨立資料檔,不會被其他檔案覆蓋
 */

export const termsContent = {
  title: "服務條款",
  titleEn: "Terms of Service",
  effectiveDate: "2026 年 4 月 3 日",
  
  introduction: `歡迎使用「未眠酒吧 Midnight Bar」(以下簡稱「本服務」)。本服務由 [你的公司/個人名稱] (以下簡稱「我們」) 提供。
使用本服務即表示您同意遵守以下條款。請仔細閱讀。`,

  sections: [
    {
      id: 1,
      title: "服務說明",
      content: `本服務是一個提供 AI 角色陪伴與塔羅占卜的互動平台。我們提供虛擬的深夜酒吧場景,讓使用者能夠與 AI 角色對話,獲得情緒支持、建議或塔羅牌解讀。`,
      important: `本服務的所有內容由 AI 生成,僅供娛樂與情緒陪伴之用,<span class="text-amber-300">不構成任何醫療、心理諮商、法律或專業建議</span>。如您有嚴重的心理健康問題,請尋求專業醫療協助。`
    },
    {
      id: 2,
      title: "使用者資格",
      list: [
        `您必須年滿 <strong class="text-amber-300">18 歲</strong> 才能使用本服務。`,
        `您必須提供真實、準確且完整的註冊資訊。`,
        `您不得冒用他人身份或提供虛假資訊。`,
        `您有責任維護帳戶安全,並對所有帳戶活動負責。`
      ]
    },
    {
      id: 3,
      title: "帳戶與安全",
      content: `註冊帳戶時,您需要提供有效的電子郵件地址並設定安全密碼。您同意:`,
      list: [
        `不與他人分享您的帳戶憑證`,
        `若發現帳戶遭未經授權使用,立即通知我們`,
        `對您帳戶下的所有活動負責`
      ]
    },
    {
      id: 4,
      title: "使用限制",
      content: `在使用本服務時,您同意不進行以下行為:`,
      list: [
        `散佈違法、暴力、色情、仇恨或騷擾性內容`,
        `嘗試破解、干擾或攻擊本服務的系統`,
        `使用自動化工具 (機器人) 濫用服務`,
        `冒充他人或虛構身份`,
        `將本服務用於任何商業目的 (未經我們書面同意)`
      ]
    },
    {
      id: 5,
      title: "訂閱與付款",
      subsections: [
        {
          subtitle: "5.1 訂閱方案",
          content: `我們提供免費與付費訂閱方案。付費方案的詳細內容請參閱「定價頁面」。`
        },
        {
          subtitle: "5.2 自動續訂",
          content: `訂閱方案將自動續訂,除非您在計費週期結束前取消訂閱。`
        },
        {
          subtitle: "5.3 退款政策",
          list: [
            `首次訂閱: 7 天內可申請全額退款`,
            `單次購買: 若完全未使用任何點數,可於購買後 3 天內申請退款`,
            `已使用的點數或服務不予退款`
          ]
        },
        {
          subtitle: "5.4 價格變更",
          content: `我們保留隨時調整價格的權利,但會提前 30 天通知現有訂閱用戶。`
        }
      ]
    },
    {
      id: 6,
      title: "使用額度與限制",
      content: `不同的訂閱方案有不同的每日/每月使用額度,包括:`,
      list: [
        `對話訊息數量`,
        `塔羅占卜次數 (單張、三張牌陣)`,
        `深度解讀次數`
      ],
      note: `額度每日/每月自動重置,不累積。單次購買的永久點數不受時間限制。`
    },
    {
      id: 7,
      title: "內容所有權與授權",
      subsections: [
        {
          subtitle: "7.1 我們的內容",
          content: `本服務的所有內容 (包括但不限於文字、圖像、設計、程式碼) 均為我們或授權方所有,受著作權法保護。`
        },
        {
          subtitle: "7.2 您的內容",
          content: `您在本服務中輸入的內容 (如對話訊息、問題) 仍屬於您,但您授予我們使用、儲存、處理該內容的權利,以提供服務。`
        },
        {
          subtitle: "7.3 AI 生成內容",
          content: `AI 生成的回覆與塔羅解讀屬於本服務的一部分。您可以個人使用,但不得用於商業目的或公開發布。`
        }
      ]
    },
    {
      id: 8,
      title: "隱私權與資料保護",
      content: `我們重視您的隱私。關於我們如何收集、使用與保護您的個人資料,請參閱我們的「隱私權政策」。`
    },
    {
      id: 9,
      title: "免責聲明",
      list: [
        `<strong>非專業建議:</strong> 本服務的所有內容僅供娛樂與情緒支持之用,不構成任何醫療、心理、法律或財務建議。`,
        `<strong>AI 限制:</strong> AI 可能產生不準確、不完整或不適當的回應。我們不對 AI 生成內容的準確性負責。`,
        `<strong>塔羅占卜:</strong> 塔羅占卜僅為靈性探索工具,不應作為重大決策的唯一依據。`,
        `<strong>服務中斷:</strong> 我們不保證服務 100% 可用,可能因維護、技術問題或不可抗力因素而中斷。`
      ]
    },
    {
      id: 10,
      title: "責任限制",
      content: `在法律允許的最大範圍內:`,
      list: [
        `我們不對因使用本服務而產生的任何直接、間接、附帶或後果性損害負責`,
        `我們的總責任不超過您在過去 12 個月內支付的費用`,
        `我們不對第三方服務 (如支付處理商) 的行為負責`
      ]
    },
    {
      id: 11,
      title: "服務終止",
      subsections: [
        {
          subtitle: "11.1 您的終止權",
          content: `您可以隨時刪除帳戶或取消訂閱。`
        },
        {
          subtitle: "11.2 我們的終止權",
          content: `如果您違反本條款,我們有權立即暫停或終止您的帳戶,且不予退款。`
        },
        {
          subtitle: "11.3 終止後的影響",
          list: [
            `您將無法存取帳戶及對話歷史`,
            `未使用的點數將失效`,
            `已支付的訂閱費用不予退還 (除非法律另有規定)`
          ]
        }
      ]
    },
    {
      id: 12,
      title: "條款變更",
      content: `我們保留隨時修改本服務條款的權利。重大變更將提前 30 天通知您 (透過 Email 或網站公告)。繼續使用服務即表示您接受修改後的條款。`
    },
    {
      id: 13,
      title: "適用法律與爭議解決",
      list: [
        `本條款受 [你的國家/地區] 法律管轄`,
        `任何爭議應優先透過友好協商解決`,
        `若協商不成,雙方同意提交至 [仲裁機構/法院] 處理`
      ]
    },
    {
      id: 14,
      title: "聯絡我們",
      content: `如對本服務條款有任何疑問,請聯繫:`,
      contact: {
        email: "info@homy.hk",
        website: "https://bar.homy.hk"
      }
    }
  ],

  footer: `使用本服務即表示您已閱讀、理解並同意遵守本服務條款。`
};